import { render, staticRenderFns } from "./SVGPhotoCut.vue?vue&type=template&id=4fb9b632&scoped=true&"
import script from "./SVGPhotoCut.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoCut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9b632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb9b632')) {
      api.createRecord('4fb9b632', component.options)
    } else {
      api.reload('4fb9b632', component.options)
    }
    module.hot.accept("./SVGPhotoCut.vue?vue&type=template&id=4fb9b632&scoped=true&", function () {
      api.rerender('4fb9b632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoCut.vue"
export default component.exports